import { styled } from '@linaria/react';
import {
  bodyFont,
  fonts,
  layout,
  radius,
  semantic,
  size,
  space,
  textStyle,
} from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    overflow: visible;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: calc(${layout.mobileNavHeight} + ${space['space-2000']});

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: ${space['space-800']};
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${space['space-200']};
`;

export const Heading = styled.h1`
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: ${textStyle.display['size-md'].fontSize};
  font-weight: ${textStyle.display['size-md'].fontWeight};
  color: ${semantic.text.primary};
  text-align: center;
  line-height: ${textStyle.display['size-md'].lineHeight};
  letter-spacing: ${textStyle.display['size-md'].letterSpacing};
  margin: ${space['space-700']} 0 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-1600']};
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  margin-top: ${space['space-800']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space['space-1000']};
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;

export const OutlinedCard = styled.div`
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('card', 'radius-xl')};
`;

export const DateSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  padding: ${space['space-800']} ${space['space-500']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1200']} ${space['space-800']};
  }

  & + & {
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }
`;

export const PreferencesCardBody = styled.div`
  padding: 0 ${space['space-500']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0 ${space['space-800']};
  }
`;

export const EmptyTimeslots = styled.p`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.tertiary};
  margin: 0;
`;
